
import React, { useEffect, useState, useRef, createRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
import Carregando from '../../components/Carregando/Carregando';
import { buscarMeusPedidosEmAndamento } from '../../services/api';
// cookies
import Cookies from 'js-cookie';


// css
import '../../styles/global.css';
import './MeusPedidosEmAndamento.css';

/* eslint-disable no-restricted-globals */

const MeusPedidosEmAndamento = () => {

    const navigate = useNavigate();
    // const nomeCliente = dadosCheckin?.statusCheckin.nome;

    const [pedidos, setPedidos] = useState([]);
    const [carregando, setCarregando] = useState(true);

    // buscar os pedidos periodicamente
    const [intervalId, setIntervalId] = useState(null);

    // vamos pegar o dadosCheckin dos cookies
    // const dadosCheckin = JSON.parse(sessionStorage.getItem('dadosCheckin')) || {};
    const dadosCheckin = JSON.parse(Cookies.get('dadosCheckin')) || {};
    const nomeCliente = dadosCheckin.nome;
    const nomeEstabelecimento = dadosCheckin.estabelecimento.nome;



    useEffect(() => {
        console.log('----- ENTROU NO MeusPedidosEmAndamento -----');

        // vamos chamar o método que faz as verificações do checkin, inclusive nos cookies.
        // verificarDadosCheckin();  // se for verificado o checkin, já será redirecionado.

        // vamos chamar o método que carrega os dados
        loadData();

    }, []);


    useEffect(() => {
        const id = setInterval(fetchPedidos, 10000); // 30 segundos
        setIntervalId(id);
        return () => clearInterval(id);
    }, []);


    
    // método que pega a localização e busca os estabelecimentos
    const loadData = async () => {
        console.log(' *** Entrou no loadData ***');
        console.log('Dados do checkin: ');
        console.log(dadosCheckin);
        try {
            await fetchPedidos(); 
        } catch (err) {
            console.log("Erro ao buscar os pedidos:", err);
        }
    };





  // buscar todos os produtos do estabelecimento, para checkar os que já tem
  const fetchPedidos = async () => {
    console.log('Entrou em fetchPedidos em MeusPedidosEmAndamento');

    try {
      const dados = await buscarMeusPedidosEmAndamento(dadosCheckin);

      console.log('*** pedidos ***', dados.pedidos);

      if (dados?.pedidos) {
        console.log('-> Pedidos: ', dados.pedidos);
        setPedidos(dados.pedidos);
        setCarregando(false);
      }
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
    }
  };

  

  if (carregando) {
    return <Carregando />;
  }

  return (
    <div autoFocus className="fichas-container">
      <TituloComponent />
      <h1 className="sub-titulo">Meus pedidos em andamento</h1>
      
      <div className="box-dados">
        {
          nomeCliente
          ?
          <p className="texto-welcome">{nomeCliente},</p>
          :
          <></>
        }
        <p className="texto-welcome">Bem-vindo ao {nomeEstabelecimento}!</p>

        {
        pedidos.length == 0 
        ?
        <p className="texto-ficha-usar">Nenhum pedido localizado.</p>
        :
        <></>
      }

      </div>



      {/* Container de quadros */}
      {pedidos.map((pedido, index) => (

          console.log('pedido = ', pedido),

          <div
            // Chave composta, pois um mesmo pedido pode ter mais de um produto.
            key={`${pedido.id}-${pedido.produto_estabelecimento_id}`}  
            data-index={index} // O índice para o swipeHandler identificar
            data-id={pedido.id} // O ID do pedido
            className="box-dados-ficha"
          >

          <p className="texto-ficha-numero">{pedido.produto_pedido_id}</p>
          <p className="texto-welcome">Mesa {pedido.numero_mesa} - Comanda {pedido.numero_comanda}</p>

          <div className="divisor">&nbsp;</div>

          <p className="texto-ficha-nome-produto">{pedido.nome_produto}</p>

          <div className="divisor">&nbsp;</div>

          <p className="texto-welcome">Quantidade: {pedido.quantidade}</p>
          <p className="texto-welcome">Data: {pedido.data_pedido} - {pedido.hora_pedido}</p>

          <div className="divisor">&nbsp;</div>

          <p className="texto-status">Status: {pedido.status_pedido}</p>

        </div>
      ))}
    </div>
  );
};

export default MeusPedidosEmAndamento;
